const isSlugEYFS = (slug: string) => {
  return slug.endsWith("early-years-foundation-stage-l");
};

export default isSlugEYFS;
